import { TypeStatus } from '@/lib/api/playbackService';
import { TypeKeyValuePair } from '@/core/generated-types';

export function getStatusDisplayText(
  status: TypeStatus,
  statusDisplayCopy: TypeKeyValuePair[],
) {
  const statusDisplayCopyIdx = statusDisplayCopy.findIndex(
    (statusMapping) => statusMapping.fields.title === status,
  );

  if (statusDisplayCopyIdx !== -1) {
    return statusDisplayCopy[statusDisplayCopyIdx].fields.value;
  }

  return status;
}
